import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import * as api from '@services/api/videoReport'

export const fetchVideoReport = createAsyncThunk(
  'videoReport/fetchVideoReports',
  async (params: any) => {
    const response = await api.fetchVidelReports(params)
    return response
  }
)

export const fetchReports = createAsyncThunk(
  'videoReport/fetchReport',
  async (params: any) => {
    const response = await api.fetchReports(params)
    return response
  }
)

export const confirm = createAsyncThunk(
  'videoReport/confirm',
  async (data: any) => {
    const response = await api.confirm(data)
    return response
  }
)

export const unconfirm = createAsyncThunk(
  'videoReport/unconfirm',
  async (data: any) => {
    const response = await api.unconfirm(data)
    return response
  }
)

export const block = createAsyncThunk(
  'videoReport/block',
  async (data: any) => {
    const response = await api.block(data)
    return response
  }
)

export const unblock = createAsyncThunk(
  'videoReport/unblock',
  async (data: any) => {
    const response = await api.unblock(data)
    return response
  }
)

export const note = createAsyncThunk(
  'videoReport/note',
  async (data: any) => {
    const response = await api.note(data)
    return response
  }
)

export const download = createAsyncThunk(
  'videoReport/download',
  async (params: any) => {
    const response = await api.download(params)
    return response
  }
)

export const approveVideo = createAsyncThunk(
  'videoReport/approveVideo',
  async (id: string) => {
    const response = await api.approve(id)
    return response
  }
)

export const getViewNumberHistories = createAsyncThunk(
  'videoReport/getViewNumberHistories',
  async (id: string) => {
    const response = await api.getViewNumberHistories(id)
    return response
  }
)

export const addViewNumberHistory = createAsyncThunk(
  'videoReport/addViewNumberHistory',
  async (params: any) => {
    const response = await api.addViewNumberHistory(params)
    return response
  }
)

export const getVideoPurchaseMethodList = createAsyncThunk(
  'videoReport/getVideoPurchaseMethodList',
  async () => {
    const response = await api.getVideoPurchaseMethodList()
    return response
  }
)

export const getSingleVideoPurchaseMethod = createAsyncThunk(
  'videoReport/getSingleVideoPurchaseMethod',
  async (id: string) => {
    const response = await api.getSingleVideoPurchaseMethod(id)
    return response
  }
)

export const addVideoPurchaseMethod = createAsyncThunk(
  'videoReport/addVideoPurchaseMethod',
  async (params: any) => {
    const response = await api.addVideoPurchaseMethod(params)
    return response
  }
)

export const updateVideoPurchaseMethod = createAsyncThunk(
  'videoReport/updateVideoPurchaseMethod',
  async (params: any) => {
    const response = await api.updateVideoPurchaseMethod(params)
    return response
  }
)

export const deleteVideoPurchaseMethod = createAsyncThunk(
  'videoReport/deleteVideoPurchaseMethod',
  async (id: string) => {
    const response = await api.deleteVideoPurchaseMethod(id)
    return response
  }
)

export const addPurchaseMethodsToVideo = createAsyncThunk(
  'videoReport/addPurchaseMethodsToVideo',
  async (params: any) => {
    const response = await api.addPurchaseMethodsToVideo(params)
    return response
  }
)

export const getVideoChoiceList = createAsyncThunk(
  'videoReport/getVideoChoiceList',
  async () => {
    const response = await api.getVideoChoiceList()
    return response
  }
)

export const getSingleVideoChoice = createAsyncThunk(
  'videoReport/getSingleVideoChoice',
  async (id: string) => {
    const response = await api.getSingleVideoChoice(id)
    return response
  }
)

export const addVideoChoice = createAsyncThunk(
  'videoReport/addVideoChoice',
  async (params: any) => {
    const response = await api.addVideoChoice(params)
    return response
  }
)

export const updateVideoChoice = createAsyncThunk(
  'videoReport/updateVideoChoice',
  async (params: any) => {
    const response = await api.updateVideoChoice(params)
    return response
  }
)

export const deleteVideoChoice = createAsyncThunk(
  'videoReport/deleteVideoChoice',
  async (id: string) => {
    const response = await api.deleteVideoChoice(id)
    return response
  }
)

export const addChoicesToVideo = createAsyncThunk(
  'videoReport/addChoicesToVideo',
  async (params: any) => {
    const response = await api.addChoicesToVideo(params)
    return response
  }
)

export const getVideoGenreList = createAsyncThunk(
  'videoReport/getVideoGenreList',
  async () => {
    const response = await api.getVideoGenreList()
    return response
  }
)

export const getSingleVideoGenre = createAsyncThunk(
  'videoReport/getSingleVideoGenre',
  async (id: string) => {
    const response = await api.getSingleVideoGenre(id)
    return response
  }
)

export const addVideoGenre = createAsyncThunk(
  'videoReport/addVideoGenre',
  async (params: any) => {
    const response = await api.addVideoGenre(params)
    return response
  }
)

export const updateVideoGenre = createAsyncThunk(
  'videoReport/updateVideoGenre',
  async (params: any) => {
    const response = await api.updateVideoGenre(params)
    return response
  }
)

export const deleteVideoGenre = createAsyncThunk(
  'videoReport/deleteVideoGenre',
  async (id: string) => {
    const response = await api.deleteVideoGenre(id)
    return response
  }
)

export const addGenresToVideo = createAsyncThunk(
  'videoReport/addGenresToVideo',
  async (params: any) => {
    const response = await api.addGenresToVideo(params)
    return response
  }
)

export const getVideoTags = createAsyncThunk(
  'videoReport/getVideoTags',
  async (id: string) => {
    const response = await api.getVideoTags(id)
    return response
  }
)

export const updateTags = createAsyncThunk(
  'videoReport/updateTags',
  async (params: any) => {
    const response = await api.updateTags(params)
    return response
  }
)

export const fetchVideoCommentList = createAsyncThunk(
  'videoReport/fetchVideoCommentList',
  async (params: any) => {
    const response = await api.fetchVideoComments(params)
    return response
  }
)

export const fetchAminNoteList = createAsyncThunk(
  'videoReport/fetchAminNoteList',
  async (id: string) => {
    const response = await api.fetchAdminNotes(id)
    return response
  }
)

export const setCommentBlocked = createAsyncThunk(
  'videoReport/setCommentBlocked',
  async (params: any) => {
    const response = await api.setCommentBlocked(params)
    return response
  }
)

export const uploadVideo = createAsyncThunk(
  'videoReport/uploadVideo',
  async (params: any) => {
    const response = await api.uploadVideo(params)
    return response
  }
)

const initialState = {
  videoList: [] as any[],
  selectedVideo: {} as any,
  pageIndex: 1,
  pageSize: 50,
  totalRecords: 0,
  totalPage: 0,
  keyword: '',
  reportStatus: 'ALL' as 'ALL' | 'REPORTED',
  checkStatus: 'ALL' as 'ALL' | 'NOTCHECKED' | 'CHECKED',
  blockStatus: 'ALL' as 'ALL' | 'NOTBLOCKED' | 'BLOCKED',
  approveStatus: 'ALL' as 'ALL' | 'APPROVED' | 'WAITING',
  postedDateStart: null,
  postedDateEnd: null,
  showNotePopup: false,
  showReports: false,
  reportList: [],
  reportsPageIndex: 1,
  reportsPageSize: 50,
  reportsTotalRecords: 0,
  reportsTotalPage: 0,
  isDownloading: false,
  isLoading: false,
  showApproveVideoConfirmDialog: false,
  selectedVideoToApproveId: '',
  showNumberOfPlayModal: false,
  selectedVideoToManageViewCountId: '',
  viewNumberHistoyList: [],
  bulkSelectedVideoPurchaseMethodSetup: [] as string[],
  purchaseMethodList: [],
  showDeletePurchaseMethodConfirmModal: false,
  selectedPurchaseMethodToDeleteId: '',
  showUpdatePurchaseMethodModal: false,
  selectedPurchaseMethodToUpdateId: '',
  updatingPurchaseMethod: { id: '', name: '' },
  bulkSelectedVideoChoiceSetup: [] as string[],
  choiceList: [],
  showDeleteChoiceConfirmModal: false,
  selectedChoiceToDeleteId: '',
  showUpdateChoiceModal: false,
  selectedChoiceToUpdateId: '',
  updatingChoice: { id: '', name: '' },
  bulkSelectedVideoGenreSetupId: '',
  bulkSelectedVideoGenreSetupName: 'ご選択ください',
  genreList: [],
  showDeleteGenreConfirmModal: false,
  selectedGenreToDeleteId: '',
  showUpdateGenreModal: false,
  selectedGenreToUpdateId: '',
  updatingGenre: { id: '', name: '' },
  selectedVideoToSetupTagId: '',
  showTagRowSetupModal: false,
  rowSelectedVideoPurchaseMethods: [] as string[],
  rowSelectedVideoChoices: [] as string[],
  rowSelectedVideoGenre: null,
  rowSelectedVideoGenreName: 'ご選択ください',
  commentList: [] as any[],
  commentFilter: {
    isReported: null,
    isBlocked: null,
    videoId: ''
  },
  showCommentModal: false,
  updatingCommentVideoId: '',
  showAdminNoteModal: false,
  adminNoteList: [] as any[],
  upsertAdminNote: {
    commentId: '',
    isBlocked: false,
    message: ''
  },
  videoInsert: {
    data: {
      title: '',
      storeId: '',
      videoUrl: '',
      video: null
    },
    videoFile: {
    } as any,
    storeCD: ''
  }
}

const videoReportSlice = createSlice({
  name: 'videoReport',
  initialState,
  reducers: {
    toggleNotePopup: state => {
      state.showNotePopup = !state.showNotePopup
    },
    toggleReports: state => {
      state.showReports = !state.showReports
    },
    selectVideo: (state, action) => {
      state.selectedVideo = action.payload
    },
    setKeyword: (state, action) => {
      state.keyword = action.payload
    },
    setReportStatus: (state, action) => {
      state.reportStatus = action.payload
    },
    setBlockStatus: (state, action) => {
      state.blockStatus = action.payload
    },
    setApproveStatus: (state, action) => {
      state.approveStatus = action.payload
    },
    setCheckStatus: (state, action) => {
      state.checkStatus = action.payload
    },
    setDownloading: (state, action) => {
      state.isDownloading = action.payload
    },
    setShowApproveVideoConfirmDialog: (state, action) => {
      state.showApproveVideoConfirmDialog = action.payload
    },
    setSelectVideoToApprove: (state, action) => {
      state.selectedVideoToApproveId = action.payload
    },
    setShowNumberOfPlayModal: (state, action) => {
      state.showNumberOfPlayModal = action.payload
    },
    setSelectedVideoToManageViewCountId: (state, action) => {
      state.selectedVideoToManageViewCountId = action.payload
    },
    setSelectedVideoToSetupTagId: (state, action) => {
      state.selectedVideoToSetupTagId = action.payload
    },
    setCheckAll: (state, action) => {
      const { videoList } = state
      videoList.forEach(video => {
        video.checked = action.payload
      })
    },
    setCheckOne: (state, action) => {
      const { videoList } = state
      const videoItem = videoList.filter(x => x.id === action.payload.id)[0]
      if (videoItem) {
        videoItem.checked = action.payload.checked
      }
    },
    setbulkSelectedVideoPurchaseMethodSetup: (state, action) => {
      const { checked, id } = action.payload
      if (checked) {
        if (!state.bulkSelectedVideoPurchaseMethodSetup.includes(id)) {
          state.bulkSelectedVideoPurchaseMethodSetup.push(id)
        }
      } else {
        const index = state.bulkSelectedVideoPurchaseMethodSetup.indexOf(id)
        if (index > -1) {
          state.bulkSelectedVideoPurchaseMethodSetup.splice(index, 1)
        }
      }
    },
    clearbulkSelectedVideoPurchaseMethodSetup: state => {
      state.bulkSelectedVideoPurchaseMethodSetup = []
    },
    setShowDeletePurchaseMethodConfirmModal: (state, action) => {
      state.showDeletePurchaseMethodConfirmModal = action.payload
    },
    setSelectedPurchaseMethodToDeleteId: (state, action) => {
      state.selectedPurchaseMethodToDeleteId = action.payload
    },
    setShowUpdatePurchaseMethodModal: (state, action) => {
      state.showUpdatePurchaseMethodModal = action.payload
    },
    setSelectedPurchaseMethodToUpdateId: (state, action) => {
      state.selectedPurchaseMethodToUpdateId = action.payload
    },
    setUpdatingPurchaseMethodName: (state, action) => {
      state.updatingPurchaseMethod.name = action.payload
    },
    setbulkSelectedVideoChoiceSetup: (state, action) => {
      const { checked, id } = action.payload
      if (checked) {
        if (!state.bulkSelectedVideoChoiceSetup.includes(id)) {
          state.bulkSelectedVideoChoiceSetup.push(id)
        }
      } else {
        const index = state.bulkSelectedVideoChoiceSetup.indexOf(id)
        if (index > -1) {
          state.bulkSelectedVideoChoiceSetup.splice(index, 1)
        }
      }
    },
    clearbulkSelectedVideoChoiceSetup: state => {
      state.bulkSelectedVideoChoiceSetup = []
    },
    setShowDeleteChoiceConfirmModal: (state, action) => {
      state.showDeleteChoiceConfirmModal = action.payload
    },
    setSelectedChoiceToDeleteId: (state, action) => {
      state.selectedChoiceToDeleteId = action.payload
    },
    setShowUpdateChoiceModal: (state, action) => {
      state.showUpdateChoiceModal = action.payload
    },
    setSelectedChoiceToUpdateId: (state, action) => {
      state.selectedChoiceToUpdateId = action.payload
    },
    setUpdatingChoiceName: (state, action) => {
      state.updatingChoice.name = action.payload
    },

    setbulkSelectedGenreSetup: (state, action) => {
      state.bulkSelectedVideoGenreSetupId = action.payload
    },
    clearbulkSelectedVideoGenreSetup: state => {
      state.bulkSelectedVideoGenreSetupId = ''
    },
    setbulkSelectedGenreNameSetup: (state, action) => {
      state.bulkSelectedVideoGenreSetupName = action.payload
    },
    clearbulkSelectedVideoGenreNameSetup: state => {
      state.bulkSelectedVideoGenreSetupName = 'ご選択ください'
    },
    setShowDeleteGenreConfirmModal: (state, action) => {
      state.showDeleteGenreConfirmModal = action.payload
    },
    setSelectedGenreToDeleteId: (state, action) => {
      state.selectedGenreToDeleteId = action.payload
    },
    setShowUpdateGenreModal: (state, action) => {
      state.showUpdateGenreModal = action.payload
    },
    setSelectedGenreToUpdateId: (state, action) => {
      state.selectedGenreToUpdateId = action.payload
    },
    setUpdatingGenreName: (state, action) => {
      state.updatingGenre.name = action.payload
    },
    setShowTagRowSetupModal: (state, action) => {
      state.showTagRowSetupModal = action.payload
    },
    setRowSelectedVideoPurchaseMethods: (state, action) => {
      const { checked, id } = action.payload
      if (checked) {
        if (!state.rowSelectedVideoPurchaseMethods.includes(id)) {
          state.rowSelectedVideoPurchaseMethods.push(id)
        }
      } else {
        const index = state.rowSelectedVideoPurchaseMethods.indexOf(id)
        if (index > -1) {
          state.rowSelectedVideoPurchaseMethods.splice(index, 1)
        }
      }
    },
    setRowSelectedVideoChoices: (state, action) => {
      const { checked, id } = action.payload
      if (checked) {
        if (!state.rowSelectedVideoChoices.includes(id)) {
          state.rowSelectedVideoChoices.push(id)
        }
      } else {
        const index = state.rowSelectedVideoChoices.indexOf(id)
        if (index > -1) {
          state.rowSelectedVideoChoices.splice(index, 1)
        }
      }
    },
    setRowSelectedVideoGenre: (state, action) => {
      state.rowSelectedVideoGenre = action.payload
    },
    setRowSelectedVideoGenreName: (state, action) => {
      state.rowSelectedVideoGenreName = action.payload
    },
    clearRowUpdateData: state => {
      state.rowSelectedVideoChoices = []
      state.rowSelectedVideoGenre = null
      state.rowSelectedVideoPurchaseMethods = []
      state.rowSelectedVideoGenreName = 'ご選択ください'
    },
    setPostedDateStart: (state, action) => {
      state.postedDateStart = action.payload
    },
    setPostedDateEnd: (state, action) => {
      state.postedDateEnd = action.payload
    },
    setShowCommentModal: (state, action) => {
      state.showCommentModal = action.payload
    },
    setCommentFilterVideoId: (state, action) => {
      state.commentFilter.videoId = action.payload
    },
    setCommentFilterIsReported: (state, action) => {
      state.commentFilter.isReported = action.payload
    },
    setCommentFilterIsBlocked: (state, action) => {
      state.commentFilter.isBlocked = action.payload
    },
    setShowAdminNoteModal: (state, action) => {
      state.showAdminNoteModal = action.payload
    },
    setUpsertAdminNoteIsBlocked: (state, action) => {
      state.upsertAdminNote.isBlocked = action.payload
    },
    setUpsertAdminNoteMessage: (state, action) => {
      state.upsertAdminNote.message = action.payload
    },
    setUpsertAdminNoteCommentId: (state, action) => {
      state.upsertAdminNote.commentId = action.payload
    },
    setInsertVideoTitle: (state, action) => {
      state.videoInsert.data.title = action.payload
    },
    setInsertVideoStoreCD: (state, action) => {
      state.videoInsert.storeCD = action.payload
    },
    setInsertVideoStoreId: (state, action) => {
      state.videoInsert.data.storeId = action.payload
    },
    setVideoFile (state, action: PayloadAction<File>) {
      const videoFile = action.payload
      if (videoFile) {
        state.videoInsert.videoFile = videoFile
      }
    },
    setIsLoading (state, action) {
      state.isLoading = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchVideoReport.fulfilled, (state, action) => {
      state.videoList = action.payload.data
      state.videoList.forEach((video: any) => {
        if (video.check) video.check = false
      })
      state.pageIndex = action.payload.pageIndex
      state.pageSize = action.payload.pageSize
      state.totalPage = action.payload.totalPage
      state.totalRecords = action.payload.totalRecords
      state.isLoading = false
    })
    builder.addCase(fetchVideoReport.pending, state => {
      state.isLoading = true
    })
    builder.addCase(getVideoPurchaseMethodList.fulfilled, (state, action) => {
      state.purchaseMethodList = action.payload.data
    })
    builder.addCase(getSingleVideoPurchaseMethod.fulfilled, (state, action) => {
      state.updatingPurchaseMethod = action.payload.data
    })
    builder.addCase(getVideoChoiceList.fulfilled, (state, action) => {
      state.choiceList = action.payload.data
    })
    builder.addCase(getSingleVideoChoice.fulfilled, (state, action) => {
      state.updatingChoice = action.payload.data
    })
    builder.addCase(getVideoGenreList.fulfilled, (state, action) => {
      state.genreList = action.payload.data
    })
    builder.addCase(getSingleVideoGenre.fulfilled, (state, action) => {
      state.updatingGenre = action.payload.data
    })
    builder.addCase(fetchReports.fulfilled, (state, action) => {
      state.reportList = action.payload.data
      state.reportsPageIndex = action.payload.pageIndex
      state.reportsPageSize = action.payload.pageSize
      state.reportsTotalPage = action.payload.totalPage
      state.reportsTotalRecords = action.payload.totalRecords
    })
    builder.addCase(getViewNumberHistories.fulfilled, (state, action) => {
      state.viewNumberHistoyList = action.payload.data
    })
    builder.addCase(getVideoTags.fulfilled, (state, action) => {
      state.rowSelectedVideoChoices = action.payload.data.choices.map((x: any) => x.id)
      state.rowSelectedVideoGenre = action.payload.data.genreId ?? null
      if (action.payload.data.genreId) {
        const genre : any = state.genreList.filter((x: any) => x.id === action.payload.data.genreId)[0]
        if (genre) {
          state.rowSelectedVideoGenreName = genre.name
        } else {
          state.rowSelectedVideoGenreName = 'ご選択ください'
        }
      }
      state.rowSelectedVideoPurchaseMethods = action.payload.data.purchaseMethods.map((x: any) => x.id)
    })

    builder.addCase(fetchVideoCommentList.fulfilled, (state, action) => {
      state.commentList = action.payload.data
      state.isLoading = false
    })
    builder.addCase(fetchVideoCommentList.pending, state => {
      state.isLoading = true
    })

    builder.addCase(fetchAminNoteList.fulfilled, (state, action) => {
      state.adminNoteList = action.payload.data
      state.isLoading = false
    })
    builder.addCase(fetchAminNoteList.pending, state => {
      state.isLoading = true
    })
  }
})

export const {
  toggleNotePopup,
  toggleReports,
  selectVideo,
  setCheckStatus,
  setReportStatus,
  setKeyword,
  setBlockStatus,
  setDownloading,
  setShowApproveVideoConfirmDialog,
  setSelectVideoToApprove,
  setApproveStatus,
  setShowNumberOfPlayModal,
  setSelectedVideoToManageViewCountId,
  setCheckAll,
  setCheckOne,
  setSelectedVideoToSetupTagId,
  setbulkSelectedVideoPurchaseMethodSetup,
  clearbulkSelectedVideoPurchaseMethodSetup,
  setShowDeletePurchaseMethodConfirmModal,
  setSelectedPurchaseMethodToDeleteId,
  setShowUpdatePurchaseMethodModal,
  setSelectedPurchaseMethodToUpdateId,
  setUpdatingPurchaseMethodName,
  setbulkSelectedVideoChoiceSetup,
  clearbulkSelectedVideoChoiceSetup,
  setShowDeleteChoiceConfirmModal,
  setSelectedChoiceToDeleteId,
  setShowUpdateChoiceModal,
  setSelectedChoiceToUpdateId,
  setUpdatingChoiceName,
  setbulkSelectedGenreSetup,
  clearbulkSelectedVideoGenreSetup,
  setShowDeleteGenreConfirmModal,
  setSelectedGenreToDeleteId,
  setShowUpdateGenreModal,
  setSelectedGenreToUpdateId,
  setUpdatingGenreName,
  clearbulkSelectedVideoGenreNameSetup,
  setbulkSelectedGenreNameSetup,
  setShowTagRowSetupModal,
  setRowSelectedVideoPurchaseMethods,
  setRowSelectedVideoChoices,
  setRowSelectedVideoGenre,
  setRowSelectedVideoGenreName,
  clearRowUpdateData,
  setPostedDateStart,
  setPostedDateEnd,
  setShowCommentModal,
  setCommentFilterVideoId,
  setCommentFilterIsReported,
  setCommentFilterIsBlocked,
  setShowAdminNoteModal,
  setUpsertAdminNoteIsBlocked,
  setUpsertAdminNoteMessage,
  setUpsertAdminNoteCommentId,
  setInsertVideoTitle,
  setInsertVideoStoreCD,
  setVideoFile,
  setInsertVideoStoreId,
  setIsLoading
} = videoReportSlice.actions

export default videoReportSlice.reducer
